// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"Label_labelWrapper__iYFaC","label":"Label_label__kl3i2","moveUp":"Label_moveUp__1FZ9G"};